import React, { useState } from 'react';
import styles from './index.module.scss';
import { Form, Card, Button } from 'react-bootstrap';


const SearchSection = (props) => {
    const [search, setSearch] = useState('');
    const [searchFilter, setSearchFilter] = useState('order');

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            props.onSearch(search, searchFilter)
        }
    };

    return (
        <section className={styles.SearchSection}>
            <Card className={styles.SearchCard}>
                <Card.Body>
                    <Form.Row>
                        <Form.Group>
                            <Form.Label>Buscar</Form.Label>
                            <Form.Control 
                                type="text"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                onKeyDown={handleKeyDown}
                                isInvalid={props.isInvalid} />
                            <Form.Control.Feedback type="invalid">No es un numero valido</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className={styles.Filter}>
                            <Form.Label>Buscar por</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={searchFilter}
                                onChange={e => setSearchFilter(e.target.value)} >
                                <option value='order'># Orden</option>
                                <option value='name'>Nombre</option>
                                <option value='phone'>Telefono</option>
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Button onClick={() => props.onSearch(search, searchFilter)}>Aplicar</Button>
                </Card.Body>
            </Card>
        </section>
    );
}

export default SearchSection;